import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Stack } from '../ui';

/**
 * NomineeEstateTabs
 *
 * Consistent tab control across nominee estate pages:
 * - Desktop: 3 buttons (Financial / Legal / Other assets)
 * - Mobile: dropdown to avoid wrapping/overflow
 */
export default function NomineeEstateTabs({ ownerSub, active }) {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 700 : false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 700);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const owner = encodeURIComponent(ownerSub || '');
  const go = (tab) => navigate(`/nominee/estate/${owner}/${tab}`);

  if (isMobile) {
    return (
      <div>
        <select
          value={active}
          onChange={(e) => go(e.target.value)}
          className="pv-select"
          style={{ width: '100%', maxWidth: 420 }}
        >
          <option value="financial">Financial</option>
          <option value="legal">Legal</option>
          <option value="other">Other assets</option>
        </select>
      </div>
    );
  }

  return (
    <Stack direction="row" gap={10} wrap="wrap">
      <Button type="button" variant={active === 'financial' ? 'primary' : 'secondary'} onClick={() => go('financial')}>
        Financial
      </Button>
      <Button type="button" variant={active === 'legal' ? 'primary' : 'secondary'} onClick={() => go('legal')}>
        Legal
      </Button>
      <Button type="button" variant={active === 'other' ? 'primary' : 'secondary'} onClick={() => go('other')}>
        Other assets
      </Button>
    </Stack>
  );
}

